$('.featured_slider').slick({
  infinite: false,
  dots: false,
  arrows: true, 
  slidesToShow: 4,
  slidesToScroll: 1,
   responsive: [
        {
      breakpoint: 1100,
      settings: {
        slidesToShow: 3,
      }
    },
       {
      breakpoint: 798,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


$('.marquee')
          .marquee({
            //If you wish to always animate using jQuery
            allowCss3Support: true
            , //works when allowCss3Support is set to true - for full list see http://www.w3.org/TR/2013/WD-css3-transitions-20131119/#transition-timing-function
            css3easing: 'linear'
            , //requires jQuery easing plugin. Default is 'linear'
            easing: 'linear'
            , //pause time before the next animation turn in milliseconds
            delayBeforeStart: 000
            , //'left', 'right', 'up' or 'down'
            direction: 'left'
            , //true or false - should the marquee be duplicated to show an effect of continues flow
            duplicated: true
            , //speed in milliseconds of the marquee in milliseconds
            duration: 30000
            , //gap in pixels between the tickers
            gap: 0
            , //on cycle pause the marquee
            pauseOnCycle: false
            , //on hover pause the marquee - using jQuery plugin https://github.com/tobia/Pause
            pauseOnHover: false
            , //the marquee is visible initially positioned next to the border towards it will be moving
            startVisible: true
          });

document.addEventListener('DOMContentLoaded', function () {
    const productMediaElements = document.querySelectorAll('.slider-main_pd li');

    // Initialize Slick Slider
    $('.slider-main_pd').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true, 
  dots: false,
  asNavFor: '.slider-thumb_pdp'
    });

    $('.slider-thumb_pdp').slick({
         slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.slider-main_pd',
  dots: false,
  arrows: false, 
  infinite: false,
  focusOnSelect: true
    });

    // Function to update slider based on media ID
    function updateSliderByMediaId(mediaId) {
        const indexToShow = Array.from(productMediaElements).findIndex(el => el.dataset.mediaId === mediaId);

        if (indexToShow >= 0) {
            $('.slider-main_pd').slick('slickGoTo', indexToShow);
        }
    }

    // Function to handle variant change
    function handleVariantChange(variantId) {
        fetch(`${window.location.pathname}.js`)
            .then(response => response.json())
            .then(product => {
                const selectedVariant = product.variants.find(variant => variant.id == variantId);

                if (selectedVariant && selectedVariant.featured_media) {
                    updateSliderByMediaId(String(selectedVariant.featured_media.id));
                }
            })
            .catch(err => console.error('Error fetching product data:', err));
    }

    // Detect variant changes dynamically
    const variantSelectors = document.querySelectorAll('[name="id"]');
    variantSelectors.forEach(selector => {
        selector.addEventListener('change', function (event) {
            const selectedVariantId = event.target.value;

            // Update URL without refreshing
            const newUrl = new URL(window.location);
            newUrl.searchParams.set('variant', selectedVariantId);
            window.history.replaceState({}, '', newUrl);

            // Update slider for the selected variant
            handleVariantChange(selectedVariantId);
        });
    });

    // Check and handle page refresh
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');

    if (variantId) {
        handleVariantChange(variantId);
    }
});


 $('.contact_image_slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true, 
  dots: false
});


 $('.gallery_slider').slick({
  slidesToShow: 3,
  slidesToScroll: 3,
  arrows: true, 
  dots: false
});